import { DataSourceWithGenerics, SearchQueryFn } from "@me8eon/data_sources";
import { DataHasType } from "@me8eon/data";
import { _makeGraphApiRequest, filtersToQueryString, GraphApiContext, GraphApiFilters, GraphApiPaging, GraphApiQuery } from "./graph.api.data.sources";

export const graphApiTeams = "graphApiTeams";

export const searchBodyForTeamsGraphApi = (query: string): GraphApiQuery => {
    return {
        "requests": [
            {
                // Use the correct entity type for Teams messages
                "entityTypes": ["chatMessage"],
                "query": {
                    "queryString": query.trim(),
                },
                // Select properties relevant for Teams messages
                "selectProperties": [
                    "body",
                    "from",
                    "createdDateTime",
                    "lastModifiedDateTime"
                ],
            },
        ],
    };
};

export const graphApiTeamsQuery = <Filters extends GraphApiFilters>(): SearchQueryFn<Filters, GraphApiPaging, GraphApiQuery> =>
    ({ filters }) => ({
        query: searchBodyForTeamsGraphApi(filtersToQueryString(filters)),
        filters,
    });

export function graphApiTeamsDs<Filters extends GraphApiFilters>({ graphApiUrl, token, MakeGraphApiRequest = _makeGraphApiRequest }: GraphApiContext): DataSourceWithGenerics<Filters, GraphApiPaging, GraphApiQuery, any, DataHasType[]> {
    return {
        type: graphApiTeams,
        plugin: "datasource",
        results: (devModeData, source, debug) => {
            debug("graphApiTeamsDs", devModeData);
            const hitContainers = devModeData.flatMap((d: any) => d.hitsContainers || []);
            const results = hitContainers.flatMap((d: any) => d.hits || []).map((d: any) => ({
                type: "teamsMessage", // mark results as Teams messages
                ...d,
                source,
            }));
            return { paging: {}, results, finished: true, aggregates: {} };
        },
        query: graphApiTeamsQuery(),
        search: (query) => MakeGraphApiRequest(graphApiUrl, token, query),
    };
}
